export const CHECKOUT_LABELS = 'checkout';
export const ACCOUNT_COMMON = 'account.common';
export const GLOBAL_PLACE_REWARDS = 'global.placeRewards';
export const GLOBAL_ACCESSIBILITY = 'global.accessibility';

export const lblRewardAndCouponTitle = 'lbl_reward_and_coupon_title';
export const AccLblMyRewardsNoRewardsMsg = 'ACC_LBL_MY_REWARDS_NO_REWARDS_MSG';
export const lblCouponSeeRedeemDates = 'lbl_coupon_seeRedeemDates';
export const lblCouponApplyToBag = 'lbl_coupon_applyToBag';
export const lblCommonAppliedToBag = 'lbl_common_applied_to_bag';
export const lblCouponExpiringSoon = 'lbl_coupon_expiringSoon';
export const lblCouponCouponValid = 'lbl_coupon_couponValid';
export const lblCouponCouponUseBy = 'lbl_coupon_couponUseBy';
export const lblCouponViewPrint = 'lbl_coupon_viewPrint';
export const lblCouponRemoveFromBag = 'lbl_coupon_removeFromBag';
export const cartIconButton = 'cartIconButton';
export const lblCouponListAvailable = 'lbl_couponlist_available';
export const lblCouponListApplied = 'lbl_couponlist_applied';
export const lblCouponPlaceCashError = 'lbl_coupon_placeCash_error';

export const lblCouponTypeReward = 'lbl_common_couponTypeReward';
export const lblCouponTypeSaving = 'lbl_common_couponTypeSaving';

const MyRewardsLabels = {
  checkout: {
    bagPage: {
      [lblRewardAndCouponTitle]: 'Rewards & Coupons',
      [lblCouponListAvailable]: 'Available',
      [lblCouponListApplied]: 'Applied',
      [lblCouponPlaceCashError]:
        'Unable to apply Place Buck coupon. See terms and conditions for rules. Note: Up to 12 Place Bucks per order.',
    },
  },
  account: {
    common: {
      [lblCommonAppliedToBag]: 'Applied to Bag',
      [lblCouponSeeRedeemDates]: 'SEE REDEEM DATES',
      [lblCouponApplyToBag]: 'APPLY TO BAG',
      [lblCouponExpiringSoon]: 'EXPIRING SOON',
      [lblCouponCouponValid]: 'Valid',
      [lblCouponCouponUseBy]: 'Use By',
      [lblCouponViewPrint]: 'VIEW & PRINT',
      [lblCouponRemoveFromBag]: 'REMOVE FROM BAG',
    },
  },
  global: {
    placeRewards: {
      [AccLblMyRewardsNoRewardsMsg]:
        'There are no available rewards. Start shopping to earn points!',
    },
  },
  accessibility: {
    [cartIconButton]: 'cart',
  },
};

export const CouponIconLabels = {
  account: {
    common: {
      [lblCouponTypeReward]: 'REWARD',
      [lblCouponTypeSaving]: 'SAVINGS',
    },
  },
};

export default MyRewardsLabels;
